export default "__VITE_ASSET__QUnGC9Pn__"